/**
 * Utilidades para manejo de URLs de imágenes
 */

/**
 * Normaliza URLs de imágenes de servicios externos como Imgur
 * Convierte URLs de página a URLs directas de imagen
 * 
 * @param {string} url - URL de la imagen
 * @returns {string|null} - URL normalizada o null si no hay URL
 */
export const normalizeImageUrl = (url) => {
  if (!url) return null;
  
  // Imgur: convertir https://imgur.com/XXXXX a https://i.imgur.com/XXXXX.jpg
  const imgurPageMatch = url.match(/^https?:\/\/(?:www\.)?imgur\.com\/(\w+)(?:\.\w+)?$/);
  if (imgurPageMatch) {
    return `https://i.imgur.com/${imgurPageMatch[1]}.jpg`;
  }
  
  // Imgur gallery/album - no se puede convertir directamente
  if (url.includes('imgur.com/a/') || url.includes('imgur.com/gallery/')) {
    console.warn('URLs de álbumes de Imgur no son soportadas directamente');
    return url;
  }
  
  // Ya es URL directa de i.imgur.com - asegurar extensión
  if (url.includes('i.imgur.com') && !url.match(/\.(jpg|jpeg|png|gif|webp)$/i)) {
    return url + '.jpg';
  }
  
  return url;
};

/**
 * Convierte URLs relativas a absolutas y normaliza URLs de Imgur
 * 
 * @param {string} url - URL de la imagen
 * @param {string} apiUrl - URL base del API (opcional)
 * @returns {string|null} - URL absoluta y normalizada
 */
export const getAbsoluteImageUrl = (url, apiUrl = process.env.REACT_APP_BACKEND_URL) => {
  if (!url) return null;
  
  // Data URLs (base64) - retornar sin cambios
  if (url.startsWith('data:')) return url;
  
  // URLs absolutas - normalizar y retornar
  if (url.startsWith('http')) {
    return normalizeImageUrl(url);
  }
  
  // URLs relativas del API
  if (url.startsWith('/api')) {
    return `${apiUrl}${url}`;
  }
  
  return normalizeImageUrl(url);
};

export default {
  normalizeImageUrl,
  getAbsoluteImageUrl
};
